export default __webpack_public_path__ + "3f76c5538027869f02e0c00201c8f4fd.png";